import React from 'react';
import './styles/main.scss';

function routesConfig(pages) {
  const [CarleadCreationPage] = pages;

  return [
    {
      path: `/`,
      exact: true,
      component: CarleadCreationPage,
      componentName: 'CarleadCreationPage',
    },
    {
      // there is no need to declare path variable
      // react router will pick this component as fallback
      component: () => <div></div>,
      componentName: 'notFoundPage',
    },
  ];
}

export default routesConfig;
